import { SyntheticEvent, useState } from 'react'
import { Autocomplete, Button, TextField, Typography, Grid } from '@mui/material'
import { useTranslation } from 'react-i18next'
import moment from 'moment-timezone'

import { useStyles } from './styles'
import { useMe, useSetUserTimezone } from 'src/hooks'
import { ETranslationNs } from 'src/types'
import { HelperWrapper } from 'src/components/helper-wrapper'
import { FONTS } from 'src/constants'

interface IUserTimezoneProps {
  handleClose: () => void
}

const UserTimezoneForm = ({ handleClose }: IUserTimezoneProps) => {
  const [t] = useTranslation([ETranslationNs.UserProfile, ETranslationNs.Validation])
  const { data: user } = useMe()
  const [timezone, setTimezone] = useState<null | string>(user?.timezone ?? null)
  const [time, setTime] = useState(moment(new Date()).tz(timezone ?? 'UTC'))
  const [error, setError] = useState<string | null>(null)
  const { mutate: changeTimezone } = useSetUserTimezone()

  const classes = useStyles()

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setTime(moment(new Date()).tz(timezone ?? 'UTC'))
  //   }, 5000)

  //   return () => {
  //     clearInterval(interval)
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [])

  const handleTimezoneChange = (_: SyntheticEvent<Element, Event>, value: string | null) => {
    setTimezone(value)
    setTime(moment(new Date()).tz(value ?? 'UTC'))
    setError(null)
  }

  const handleTimezoneSubmit = () => {
    if (!timezone) {
      return setError(t('user-time-zone-form-input-error.v', { ns: ETranslationNs.Validation }))
    }

    if (timezone === user?.timezone) {
      return handleClose()
    }

    setError(null)
    changeTimezone({ timezone })
    handleClose()
  }

  return (
    <>
      <div className={classes.upperWrapper}>
        <Typography className={classes.title}>
          <HelperWrapper t="user-time-zone-form-title" ns={ETranslationNs.UserProfile} />
        </Typography>
        <Autocomplete
          value={timezone}
          disablePortal
          options={moment.tz.names()}
          sx={{ width: '100%' }}
          onChange={handleTimezoneChange}
          renderInput={(params) => (
            <TextField
              helperText={error}
              FormHelperTextProps={{ error: !!error }}
              {...params}
              autoComplete="off"
              label={t('time-zone-input-label.v')}
              InputLabelProps={{ className: classes.inputLabel }}
            />
          )}
        />
      </div>
      <Grid container direction={'column'} alignItems={'start'} px={'14px'}>
        <Grid item>
          <Typography color={'primary'} fontSize={FONTS.SIZES.m} sx={{ direction: 'row' }}>
            {timezone ? <>{time.format('HH:mm dddd')} &nbsp;</> : ''}
          </Typography>
        </Grid>
        <Grid item>
          <Typography color={'inherit'} fontSize={FONTS.SIZES.m} sx={{ direction: 'row' }}>
            {timezone ? (
              <>
                {time.format('D MMMM YYYY')} ({timezone.replace('_', ' ') ?? 'UTC'})
              </>
            ) : (
              ''
            )}
          </Typography>
        </Grid>
      </Grid>
      <Button fullWidth variant="contained" onClick={handleTimezoneSubmit} type="button">
        <HelperWrapper t="user-time-zone-form-submit" ns={ETranslationNs.UserProfile} />
      </Button>
    </>
  )
}

export { UserTimezoneForm }
